import React, { useState } from "react";
import Select from "react-select";
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch } from '../../core/data/redux/store';
import { createTrainer, updatetrainer } from "../data/redux/training/trainer/trainerAction";
import { Drawer, message } from "antd";



interface TrainerModalProps {
  visible: boolean;
  onClose: () => void;
  employees: any;
}

const TrainerForm: React.FC<TrainerModalProps> = ({ visible, onClose, employees }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const { trainer, loading } = useSelector((state: any) => state.training.trainer);
  const [errors, setErrors] = useState<any>({});
  const [formData, setFormData] = useState<any>({
    Name: "",
    phone: "",
    email: "",
    dob: "",
    address: "",
    description: "",
    status: "",
    trainerType: "Employee",
    instituteName: "",
  });

  const formatDateForInput = (dateString: string) => {
    if (!dateString) return "";
    return new Date(dateString).toISOString().split("T")[0];
  };


  const statusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];

  const trainerTypes = [
    { value: "Employee", label: "Employee" },
    { value: "Third_party", label: "Third Party" },
  ];

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSelectChange = (selectedOption: any, field: any) => {
    setFormData({ ...formData, [field]: selectedOption.value });
  };

  const validateForm = () => {
    let formIsValid = true;
    let newErrors: any = {
      Name: '',
      phone: '',
      email: '',
      dob: '',
      address: '',
      description: '',
      status: '',
      trainerType: '',
      instituteName: '',
    };

    // Name validation: no special characters, only letters and spaces allowed
    if (!formData.Name.trim()) {
      formIsValid = false;
      newErrors.Name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(formData.Name.trim())) {
      formIsValid = false;
      newErrors.Name = 'Name should not contain special characters or numbers.';
    }

    // Phone number validation: must be numeric and more than 10 digits
    if (!formData.phone.trim()) {
      formIsValid = false;
      newErrors.phone = 'Phone number is required.';
    } else if (!/^\d{10}$/.test(formData.phone.trim())) {
      formIsValid = false;
      newErrors.phone = 'Phone number must be exactly 10 digits.';
    }


    // Email validation
    if (!formData.email.trim()) {
      formIsValid = false;
      newErrors.email = 'Email is required.';
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      formIsValid = false;
      newErrors.email = 'Enter a valid email.';
    }

    // DOB validation
    if (!formData.dob.trim()) {
      formIsValid = false;
      newErrors.dob = 'Date of Birth is required.';
    }

    // Address validation
    if (!formData.address.trim()) {
      formIsValid = false;
      newErrors.address = 'Address is required.';
    }



    // Status validation
    if (!formData.status || formData.status === 'Select') {
      formIsValid = false;
      newErrors.status = 'Status is required.';
    }

    // Trainer Type validation
    if (!formData.trainerType || formData.trainerType === 'Select') {
      formIsValid = false;
      newErrors.trainerType = 'Trainer Type is required.';
    }

    setErrors(newErrors);
    return formIsValid;
  };


  const handleSubmit = (e: any) => {
    e.preventDefault();


    if (!validateForm()) return;

    const payload = {
      ...formData,
      createdBy: user.UserId,
    };

    dispatch(createTrainer(payload))
      .then((res) => {
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          setFormData({
            Name: "",
            phone: "",
            email: "",
            dob: "",
            address: "",
            description: "",
            status: "Active",
            trainerType: "Employee",
            instituteName: "",
          })
          onClose()
        } else {
          message.warning(res.payload.message);
        }
      });
  };


  return (
    <Drawer
      title="Add Trainer"
      placement="right"
      onClose={onClose}
      open={visible}
      width={480}
      style={{ marginTop: 50, paddingBottom: 50 }}
    >
      <form onSubmit={handleSubmit}>
        <div className="modal-body pb-0">
          <div className="row">
            <div className="col-md-12">
              <div className="mb-3">
                <label className="form-label">Trainer Type <span className="text-danger"> *</span></label>
                <select
                  className="form-control"
                  name="trainerType"
                  value={formData.trainerType}
                  onChange={handleChange}
                >
                  {trainerTypes.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                {errors.trainerType && <div style={{ color: "red" }}>{errors.trainerType}</div>}
              </div>
              {formData.trainerType === "Third_party" && (
                <div className="mb-3">
                  <label className="form-label">Institute Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="instituteName"
                    value={formData.instituteName}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Name <span className="text-danger">*</span>
                </label>

                {formData.trainerType === "Employee" ? (
                  <Select
                    className="select"
                    options={employees.map((emp: any) => ({
                      label: emp.Name,
                      value: emp.EmployeeID,
                    }))}
                    value={
                      employees
                        .map((emp: any) => ({
                          label: emp.Name,
                          value: emp.EmployeeID,
                        }))
                        .find((opt: any) => opt.label === formData.Name) || null
                    }
                    onChange={(selected: any) =>
                      setFormData((prev: any) => ({
                        ...prev,
                        Name: selected.label,

                        phone:
                          employees.find((emp: any) => emp.EmployeeID === selected.value)
                            ?.Phone || "",

                        email:
                          employees.find((emp: any) => emp.EmployeeID === selected.value)
                            ?.email || "",

                        // ✅ ONLY NEW LINE ADDED
                        dob: formatDateForInput(
                          employees.find((emp: any) => emp.EmployeeID === selected.value)
                            ?.DateOfBirth
                        ),
                      }))
                    }
                    placeholder="Select Employee"
                  />
                ) : (
                  <input
                    type="text"
                    className="form-control"
                    name="Name"
                    value={formData.Name}
                    onChange={handleChange}
                  />
                )}

                {errors.Name && <div style={{ color: "red" }}>{errors.Name}</div>}
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Phone<span className="text-danger"> *</span></label>
                <input
                  type="number"
                  className="form-control"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}

                />
                {errors.phone && <div style={{ color: "red" }}>{errors.phone}</div>}
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-3">
                <label className="form-label">Email <span className="text-danger"> *</span></label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}

                />
                {errors.email && <div style={{ color: "red" }}>{errors.email}</div>}
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-3">
                <label className="form-label">Date of Birth <span className="text-danger"> *</span></label>
                <input
                  type="date"
                  className="form-control"
                  name="dob"
                  value={formData.dob}
                  max={(() => {
                    const today = new Date();
                    const year = today.getFullYear() - 18;
                    const month = String(today.getMonth() + 1).padStart(2, "0");
                    const day = String(today.getDate()).padStart(2, "0");
                    return `${year}-${month}-${day}`;
                  })()}
                  onChange={handleChange}
                  disabled={formData.trainerType === "Employee"}
                />
                {errors.dob && <div style={{ color: "red" }}>{errors.dob}</div>}
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-3">
                <label className="form-label">Address <span className="text-danger"> *</span></label>
                <input
                  type="text"
                  className="form-control"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}

                />
                {errors.address && <div style={{ color: "red" }}>{errors.address}</div>}
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-3">
                <label className="form-label">Status <span className="text-danger"> *</span></label>
                <Select
                  className="select"
                  options={statusOptions}
                  value={statusOptions.find((s) => s.value === formData.status)}
                  onChange={(selected: any) => handleSelectChange(selected, "status")}
                />
                {errors.status && <div style={{ color: "red" }}>{errors.status}</div>}
              </div>
            </div>

            <div className="col-md-12">
              <div className="mb-3">
                <label className="form-label">Description </label>
                <textarea
                  className="form-control"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}

                />
                {errors.description && <div style={{ color: "red" }}>{errors.description}</div>}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-light me-2" onClick={onClose}>
            Cancel </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Adding...
              </>
            ) : (
              'Add Trainer'
            )}
          </button>



        </div>
      </form>
    </Drawer>
  );
};

export default TrainerForm;
